export class EmployeeModel {
    entityCode: number;
    year: number;
    version: number;
  }
  